import {
    ReaderLayout,
} from "../areas";

import { BookPage } from "./itjakub.plugins.reader";

class ReaderPagination {
    protected readonly pagerDisplayPages: number;
    protected clickedMoveToPage: boolean;
    public readerContainer: HTMLElement;
    public pages: Array<BookPage>;
    protected parentReader: ReaderLayout;
    /**
     * maybe a better, more explicit name for the more generic (and thus less
     * useful, less expressive, I’d say) `parentReader`?
     */
    protected readerLayout: ReaderLayout;
    public currentPageIndex = 0;
    private pageChangedCallback: (
        pageId: number, pageIndex: number, scrollTo: boolean, pageXmlId: string,
    ) => void;

    constructor(readerContainer: HTMLElement) {
        this.pagerDisplayPages = 5;
        this.readerContainer = readerContainer;
    }

    init(
        pageChangedCallback: (
            pageId: number, pageIndex: number, scrollTo: boolean, pageXmlId: string,
        ) => void,
    ) {
        this.pageChangedCallback = pageChangedCallback;
    }

    createPagination(
        multiStepArrow = false,
        clickedPaginationLinkCallback?: (pageIndex: number) => void,
        clickedPageNumberCallback?: (pageId: number, pageXmlId: string) => void,
    ): HTMLElement
    {
        const paginationUl: HTMLUListElement = document.createElement("ul");
        paginationUl.classList.add("pagination", "pagination-sm");

        const toLeft = document.createElement("ul");
        toLeft.classList.add("page-navigation-container", "page-navigation-container-left");

        let liElement: HTMLLIElement = document.createElement("li");
        $(liElement).addClass("page-navigation page-navigation-left");
        let anchor: HTMLAnchorElement = document.createElement("a");
        anchor.href = "#";
        $(anchor).text("|<");
        $(anchor).click((event: JQuery.Event) => {
            event.stopPropagation();
            if (clickedPaginationLinkCallback) {
                clickedPaginationLinkCallback(0)
            } else {
                this.moveToPageNumber(0, true);
            }
            return false;
        });
        liElement.appendChild(anchor);
        toLeft.appendChild(liElement);

        if (multiStepArrow) {
            liElement = document.createElement("li");
            $(liElement).addClass("page-navigation page-navigation-left");
            anchor = document.createElement("a");
            anchor.href = "#";
            $(anchor).text("<<");
            $(anchor).click((event: JQuery.Event) => {
                event.stopPropagation();
                if (clickedPaginationLinkCallback) {
                    clickedPaginationLinkCallback(this.currentPageIndex - 5)
                } else {
                    this.moveToPageNumber(this.currentPageIndex - 5, true);
                }
                return false;
            });
            liElement.appendChild(anchor);
            toLeft.appendChild(liElement);
        }


        let toRight = document.createElement("ul");
        toRight.classList.add("page-navigation-container", "page-navigation-container-right");

        liElement = document.createElement("li");
        $(liElement).addClass("page-navigation page-navigation-left");
        anchor = document.createElement("a");
        anchor.href = "#";
        $(anchor).text("<");
        $(anchor).click((event: JQuery.Event) => {
            event.stopPropagation();
            if (clickedPaginationLinkCallback) {
                clickedPaginationLinkCallback(this.currentPageIndex - 1)
            } else {
                this.moveToPageNumber(this.currentPageIndex - 1, true);
            }
            return false;
        });
        liElement.appendChild(anchor);
        toLeft.appendChild(liElement);

        liElement = document.createElement("li");
        $(liElement).addClass("page-navigation page-navigation-right");
        anchor = document.createElement("a");
        anchor.href = "#";
        $(anchor).text(">");
        $(anchor).click((event: JQuery.Event) => {
            event.stopPropagation();
            if (clickedPaginationLinkCallback) {
                clickedPaginationLinkCallback(this.currentPageIndex + 1)
            } else {
                this.moveToPageNumber(this.currentPageIndex + 1, true);
            }
            return false;
        });
        liElement.appendChild(anchor);
        toRight.appendChild(liElement);


        if (multiStepArrow) {
            liElement = document.createElement("li");
            $(liElement).addClass("page-navigation page-navigation-right");
            anchor = document.createElement("a");
            anchor.href = "#";
            $(anchor).text(">>");
            $(anchor).click((event: JQuery.Event) => {
                event.stopPropagation();
                if (clickedPaginationLinkCallback) {
                    clickedPaginationLinkCallback(this.currentPageIndex + 5)
                } else {
                    this.moveToPageNumber(this.currentPageIndex + 5, true);
                }
                return false;
            });
            liElement.appendChild(anchor);
            toRight.appendChild(liElement);
        }

        liElement = document.createElement("li");
        $(liElement).addClass("page-navigation page-navigation-right");
        anchor = document.createElement("a");
        anchor.href = "#";
        $(anchor).text(">|");
        $(anchor).click((event: JQuery.Event) => {
            event.stopPropagation();
            if (clickedPaginationLinkCallback) {
                clickedPaginationLinkCallback(this.pages.length - 1)
            } else {
                this.moveToPageNumber(this.pages.length - 1, true);
            }
            return false;
        });
        liElement.appendChild(anchor);
        toRight.appendChild(liElement);

        liElement = document.createElement("li");
        $(liElement).addClass("more-pages more-pages-left");
        $(liElement).text("...");
        paginationUl.appendChild(liElement);

        $.each(this.pages, (index, page) => {
            liElement = document.createElement("li");
            $(liElement).addClass("page");
            // NOTE: the BookPage property carries an underlying index that is
            //       stable even after other pagination has been filtered out
            //  XXX: and we could even store a pageId that is totally guaranteed
            //       to be stable throughout and not depend on anything at all
            // NOTE: the jQuery data property is stored somewhere privately
            $(liElement).data("page-index", page.pageIndex);
            // NOTE: a pre-generated xml:id is more likely to be unique, even
            //       compared to (Page)Resource, as currently created in
            //       UpdatePagesSubtask
            liElement.dataset['xmlId'] = page.xmlId;
            anchor = document.createElement("a");
            anchor.href = "#";
            $(anchor).text(page.text);
            $(anchor).click((event: JQuery.Event) => {
                event.stopPropagation();
                if(clickedPageNumberCallback) {
                    clickedPageNumberCallback(page.pageId, page.xmlId);
                } else {
                    this.moveToPage(page.pageId, null, page.xmlId);
                }
                return false;
            });
            liElement.appendChild(anchor);
            paginationUl.appendChild(liElement);
        });

        liElement = document.createElement("li");
        $(liElement).addClass("more-pages more-pages-right");
        $(liElement).text("...");
        paginationUl.appendChild(liElement);

        var listingContainer = document.createElement("div");
        listingContainer.classList.add("page-navigation-container-helper");
        listingContainer.appendChild(toLeft);
        listingContainer.appendChild(paginationUl);
        listingContainer.appendChild(toRight);

        return listingContainer;
    }

    /**
     * NOTE: the xml:id is recognized as a parameter only for debugging purposes
     *       (it brings some user-readable information and clarity)
     */
    moveToPageNumber(
        pageIndex: number, scrollTo: boolean, pageXmlId: string = null)
    {
        if (pageIndex < 0) {
            pageIndex = 0;
        } else if (pageIndex >= this.pages.length) {
            pageIndex = this.pages.length - 1;
        }

        if (!scrollTo) {
            this.clickedMoveToPage = true;
        }

        const page: BookPage = this.pages[pageIndex];

        if (!page) {
            console.warn('No page defined at index', pageIndex);
            return;
        }

        this.currentPageIndex = pageIndex;
        this.updatePagination(pageIndex);

        const pageId = page.pageId;
        this.pageChangedCallback.call(
            null, pageId, pageIndex, scrollTo, pageXmlId);
    }

    updatePagination(pageIndex: number)
    {
        const pager = $(this.readerContainer).find("ul.pagination");
        pager.find("li.page-navigation").css("visibility", "visible");
        pager.find("li.more-pages").css("visibility", "visible");
        if (pageIndex === 0) {
            pager.find("li.page-navigation-left").css("visibility", "hidden");
            pager.find("li.more-pages-left").css("visibility", "hidden");
        } else if (pageIndex === this.pages.length - 1) {
            pager.find("li.page-navigation-right").css("visibility", "hidden");
            pager.find("li.more-pages-right").css("visibility", "hidden");
        }

        const pages = $(pager).find(".page");
        $(pages).css("display", "none");
        $(pages).removeClass("page-active");
        const currentPage = $(pages).filter(function (index)
        {
            return $(this).data("page-index") === pageIndex;
        });

        const displayPagesOnEachSide = (this.pagerDisplayPages - 1) / 2;
        let displayOnRight = displayPagesOnEachSide;
        let displayOnLeft = displayPagesOnEachSide;
        const pagesOnLeft = pageIndex;
        const pagesOnRight = this.pages.length - (pageIndex + 1);
        if (pagesOnLeft <= displayOnLeft) {
            displayOnRight += displayOnLeft - pagesOnLeft;
            pager.find("li.more-pages-left").css("visibility", "hidden");
        } else if (pagesOnRight <= displayOnRight) {
            displayOnLeft += displayOnRight - pagesOnRight;
            pager.find("li.more-pages-right").css("visibility", "hidden");
        }

        const displayedPages = $(pages).filter(function (index) {
            const itemPageIndex = $(this).data("page-index");
            return (itemPageIndex >= pageIndex - displayOnLeft && itemPageIndex <= pageIndex + displayOnRight);
        });
        $(displayedPages).css("display", "inline-block");
        $(currentPage).addClass("page-active");
    }

    /**
     * **TODO:** switch to pageXmlId everywhere, if possible
     */
    moveToPage(pageId: number, scrollTo = false, pageXmlId: string = null)
    {
        /*
        let pageIndex = -1;
        for (let i = 0; i < this.pages.length; i++) {
            if (this.pages[i].pageId === pageId) {
                pageIndex = i;
                break;
            }
        }
        */

        // TODO: switch to xml:ids everywhere, if possible
        // NOTE: they are transparent – and a bit more likely to be non-ambiguous
        const page: BookPage =
            pageXmlId ?
            this.parentReader.pagesByXmlIds[pageXmlId]:
            this.parentReader.pagesById[pageId];

        const pageIndex = page.pageIndex;

        if (pageIndex >= 0 && pageIndex < this.pages.length) {
            this.moveToPageNumber(pageIndex, scrollTo, pageXmlId);
        }
    }
}

export { ReaderPagination };
